export default "__VITE_ASSET__BFW7iKcC__"